import React, { useEffect, useState } from 'react';
import { useParams, useHistory, useNavigate } from 'react-router-dom';
import { db,storage } from '../FireBase'; // Import Firestore
import { collection, query, where, getDocs, doc, getDoc, addDoc,updateDoc} from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL} from "firebase/storage";
import { Container, Table, Alert, Button, Modal, Form,Row,Col,Card ,Tab,Tabs} from 'react-bootstrap';
import { faEdit, faFaceAngry, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ToastAlert from '../components/ToastAlert';
import { Link } from 'react-router-dom';
import '../css/font.css';
import Loading from '../components/Loading';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaBoxesPacking, FaNoteSticky, FaPrint } from 'react-icons/fa6';
import axios from 'axios';



const ProcessScheme = () => {
    const { id } = useParams(); // Get the scheme ID from the URL
    const [scheme, setScheme] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const navigate = useNavigate(); // Initialize useNavigate
    const [paidcustomers, setPaidCustomers] = useState([]); 
    const [customers, setCustomers] = useState([]); 
    const [Unpaidcustomers, setUnpaidCustomers] = useState([]); 
    const [products, setProducts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [scannedBarcodes, setScannedBarcodes] = useState({});
    const [barcodeError, setBarcodeError] = useState('');
    const [packedOrders, setPackedOrders] = useState([]);
    const [billedOrders, setBilledOrders] = useState([]);
    const [processedOrders,setProcessedOrders] = useState([]);
    
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderNotes, setOrderNotes] = useState('');
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [billingUsers, setBillingUsers] = useState([]);
    const [logisticsUsers, setLogisticsUsers] = useState([]);
    const [selectedBillingUser, setSelectedBillingUser] = useState([]);
    const [selectedLogisticsUser, setSelectedLogisticsUser] = useState([]);
    const [selectedCompletedUsers, setSelectedCompletedUsers] = useState([]);
    const [activeTab, setActiveTab] = useState('unbilled');

    const [currentUser, setCurrentUser] = useState(null);
    const [trackingLink, setTrackingLink] = useState('');
    const [uploadedSlip, setUploadedSlip] = useState(null);
    const [uploadedSlipURL, setUploadedSlipURL] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [scannedQuantities, setScannedQuantities] = useState({});
    const [totalProducts, setTotalProducts] = useState([]);


   const [unBilledCustomers,setUnBilledCustomers]=useState([]);
   const [billedCustomers,setBilledCustomers]=useState([]);
   const [selectedPriceRanges, setSelectedPriceRanges] = useState({});
   const [contactDetails, setContactDetails] = useState({});
      

  
    useEffect(() => {
        fetchCurrentUser();
        fetchData();
    }, [id]);

    const fetchData = async () => {
        await fetchPackedOrders();
        await fetchCustomers();
        await fetchSchemeDetails();
        await fetchProductDetails();
        await fetchBillingUsers();
        await fetchLogisticsUsers();
        await fetchBilledOrders();
        await fetchProcessedOrders();
        await fetchBilledCustomers();
        await fetchUnBilledCustomers();
        await fetchContactDetails();
    };
    const syncData =async()=>{
        setToastMessage("Synchronization!!!");
        setToastVariant('warning');
        setShowToast(true);
        await fetchData();
        setToastMessage("Synchronization Complete!!!");
        setToastVariant('success');
        setShowToast(true);
        
    }
    const fetchBillingUsers = async () => {
        try {
            const billingQuery = query(collection(db, 'crm_users'), where('role', '==', 'Billing'));
            const billingSnapshot = await getDocs(billingQuery);
            const billingData = billingSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setBillingUsers(billingData);
        } catch (error) {
            console.error('Error fetching billing users:', error);
        }
    };

    const fetchLogisticsUsers = async () => {
        try {
            const logisticsQuery = query(collection(db, 'crm_users'), where('role', '==', 'Logistics'));
            const logisticsSnapshot = await getDocs(logisticsQuery);
            const logisticsData = logisticsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setLogisticsUsers(logisticsData);
        } catch (error) {
            console.error('Error fetching logistics users:', error);
        }
    };
    const fetchCurrentUser = async () => {
        try {
            const storedUser = JSON.parse(sessionStorage.getItem('user')); // Assuming the user object is stored as a JSON string
            if (storedUser && storedUser.uid) {
                const userRef = doc(db, 'crm_users', storedUser.uid);
                const userDoc = await getDoc(userRef);
                if (userDoc.exists()) {
                    setCurrentUser({ id: userDoc.id, ...userDoc.data() });
                } else {
                    console.log('No such user document!');
                }
            }
        } catch (error) {
            console.error('Error fetching current user:', error);
        }
    };

  
  
   

    const fetchSchemeDetails = async () => {
        try {
            const schemeRef = doc(db, 'schemes', id);
            const schemeDoc = await getDoc(schemeRef);
            if (schemeDoc.exists()) {
                const schemeData = { id: schemeDoc.id, ...schemeDoc.data() };
                setScheme(schemeData);
                fetchProductDetails(schemeData);
            } else {
                console.log('No such document!');
            }
        } catch (error) {
            console.error('Error fetching scheme details:', error);
            
        }
    };

    const fetchCustomers = async () => {
        try {
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs.map(doc => doc.data().userId);

            const customerPromises = userIds.map(async userId => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    return { id: userDoc.id, ...userDoc.data() };
                } else {
                    console.log(`No such user document for userId: ${userId}`);
                    return null;
                }
            });

            const customersData = await Promise.all(customerPromises);
            setCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers:', error);
          
        }
    };

    const fetchUnBilledCustomers = async () => {
        try {
            const storedUser = JSON.parse(sessionStorage.getItem('user'));
            console.log(storedUser)
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id), where('billingStatus','==','Assigned-for-billing'),where('billingUserId','==', storedUser.uid));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs
                .filter(doc => parseInt(doc.data().totalMonths) ===parseInt( doc.data().paidMonths))
                .map(doc => doc.data().userId);

            const customerPromises = userIds.map(async userId => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    const subscriptionDoc = subscriptionsSnapshot.docs.find(doc => doc.data().userId === userId);
                    return { id: userDoc.id, ...userDoc.data(),  
                        billingUserId: subscriptionDoc.data().billingUserId,
                        logisticsUserId: subscriptionDoc.data().logisticsUserId,
                        quantity: subscriptionDoc.data().quantity,
                        billingUserName:subscriptionDoc.data().billingUsername,
                        logisticsUserName:subscriptionDoc.data().logisticsUsername,
                };
                } else {
                    console.log(`No such user document for userId: ${userId}`);
                    return null;
                }
            });

            const customersData = await Promise.all(customerPromises);
            setUnBilledCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers:', error);
           
        }
    };


    const fetchBilledCustomers = async () => {
        try {
            const storedUser = JSON.parse(sessionStorage.getItem('user'));
            console.log(storedUser)
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id), where('billingStatus','==','Billed'),where('billingUserId','==', storedUser.uid));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs
                .filter(doc => parseInt(doc.data().totalMonths) ===parseInt( doc.data().paidMonths))
                .map(doc => doc.data().userId);

            const customerPromises = userIds.map(async userId => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    const subscriptionDoc = subscriptionsSnapshot.docs.find(doc => doc.data().userId === userId);
                    return { id: userDoc.id, ...userDoc.data(),  
                        billingUserId: subscriptionDoc.data().billingUserId,
                        logisticsUserId: subscriptionDoc.data().logisticsUserId,
                        schemeId:subscriptionDoc.data().schemeId,
                        invoiceNumber:subscriptionDoc.data().invoiceNumber,
                };
                } else {
                    console.log(`No such user document for userId: ${userId}`);
                    return null;
                }
            });

            const customersData = await Promise.all(customerPromises);
            setBilledCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers:', error);
           
        }
    };


   const fetchProductDetails = async (schemeData) => {
          try {
              if (schemeData && schemeData.productDetails) {
                  const productPromises = schemeData.productDetails.map(async product => {
                      const productRef = doc(db, 'products', product.productId);
                      const productDoc = await getDoc(productRef);
                      if (productDoc.exists()) {
                          const productData = productDoc.data();
                          return {
                              id: productDoc.id,
                              ...productData,
                              quantity: product.quantity,
                              priceRanges: productData.priceRanges || [], // Include price ranges
                          };
                      } else {
                          console.log(`No such product document for productId: ${product.productId}`);
                          return null;
                      }
                  });
      
                  const productsData = await Promise.all(productPromises);
                  setProducts(productsData.filter(product => product !== null));
              }
          } catch (error) {
              console.error('Error fetching product details:', error);
          }
      };

    const fetchPackedOrders = async () => {
        try {
            const packedOrdersQuery = query(collection(db, 'order-processing'), where('status', '==', 'Packed'), where('schemeId', '==', id));
            const packedOrdersSnapshot = await getDocs(packedOrdersQuery);
            const packedOrdersData = packedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPackedOrders(packedOrdersData);
        } catch (error) {
            console.error('Error fetching packed orders:', error);
          
        }
    };
    const fetchBilledOrders = async () => {
        try {
            const billedOrdersQuery = query(collection(db, 'order-processing'), where('BillingStatus', '==', 'Billed'), where('schemeId', '==', id));
            const billedOrdersSnapshot = await getDocs(billedOrdersQuery);
            const billedOrdersData = billedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setBilledOrders(billedOrdersData);
        } catch (error) {
            console.error('Error fetching packed orders:', error);
          
        }
    };
    const fetchProcessedOrders = async () => {
        try {
            const processedOrdersQuery = query(collection(db, 'order-processing'), where('PackingStatus', '==', 'Packed'), where('schemeId', '==', id));
            const processedOrdersSnapshot = await getDocs(processedOrdersQuery);
            const processedOrdersData = processedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setProcessedOrders(processedOrdersData);
        } catch (error) {
            console.error('Error fetching packed orders:', error);
          
        }
    };
    

    
    const handleShowModal = (customer) => {
        setSelectedCustomer(customer);
        console.log(customer)
        const totalProducts = products.map(product => ({
            ...product,
            totalQuantity: customer.quantity * product.quantity
        }));
        setTotalProducts(totalProducts);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setScannedQuantities({});
        setShowModal(false);
        setSelectedCustomer(null);
        setScannedBarcodes({});
        setBarcodeError('');
    };

    const handleBarcodeChange = (productId, barcode) => {
        const product = totalProducts.find(product => product.id === productId);
        if (barcode === product.barcode) {
            if ((scannedQuantities[productId] || 0) < product.totalQuantity) {
                setScannedQuantities(prevState => ({
                    ...prevState,
                    [productId]: (prevState[productId] || 0) + 1
                }));
                setScannedBarcodes(prevState => ({
                    ...prevState,
                    [productId]: ''
                }));
            } else {
                setToastMessage(`Scanned quantity for product: ${product.name} cannot exceed total quantity`);
                setToastVariant('danger');
                setShowToast(true);
            }
        } else {
            setScannedBarcodes(prevState => ({
                ...prevState,
                [productId]: barcode
            }));
        }
    };

       const fetchContactDetails = async () => {
            try {
                const contactRef = doc(db, 'settings', 'contact');
                const contactDoc = await getDoc(contactRef);
                if (contactDoc.exists()) {
                    setContactDetails(contactDoc.data());
                } else {
                    console.log('No such document!');
                }
            } catch (error) {
                console.error('Error fetching contact details:', error);
            }
        };
    
  const handleSubmit = async () => {
         setIsLoading(true);
         try {
            const invoiceNumber = `INV-${Date.now()}`;
             for (const product of totalProducts) {
                 const selectedPriceRangeIndex = selectedPriceRanges[product.id];
                 if (selectedPriceRangeIndex === undefined) {
                     setToastMessage(`Please select a price range for product: ${product.name}`);
                     setToastVariant('danger');
                     setShowToast(true);
                     setIsLoading(false);
                     return;
                 }
     
                 const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
                 if ((scannedQuantities[product.id] || 0) < product.totalQuantity) {
                     setToastMessage(`Insufficient scanned quantity for product: ${product.name}`);
                     setToastVariant('danger');
                     setShowToast(true);
                     setBarcodeError(`Insufficient scanned quantity for product: ${product.name}`);
                     setIsLoading(false);
                     return;
                 }
     
                 if (selectedPriceRange.stock < product.totalQuantity) {
                     setToastMessage(`Insufficient stock for product: ${product.name} at price: ${selectedPriceRange.price}`);
                     setToastVariant('danger');
                     setShowToast(true);
                     setIsLoading(false);
                     return;
                 }
             }
     
             // Update stock quantity in the products collection
    
         for (const product of totalProducts) {
             const selectedPriceRangeIndex = selectedPriceRanges[product.id]; // Get selected price range index
             if (selectedPriceRangeIndex === undefined) {
                 console.error(`No price range selected for product: ${product.name}`);
                 continue;
             }
 
             const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex]; // Get selected price range
             if (!selectedPriceRange) {
                 console.error(`Price range index out of bounds for product: ${product.name}`);
                 continue;
             }
 
             console.log(`Updating stock for ${product.name}, Price: ${selectedPriceRange.price}, Current Stock: ${selectedPriceRange.stock}, Deducting: ${product.totalQuantity}`);
 
             // Deduct stock only for the selected price range
             const updatedPriceRanges = product.priceRanges.map((priceRange) =>
                 priceRange.price === selectedPriceRange.price
                     ? { ...priceRange, stock: Math.max(priceRange.stock - product.totalQuantity, 0) } // Ensure stock never goes negative
                     : priceRange
             );
 
             // Check if stock is actually updated
             console.log(`Updated price ranges for ${product.name}:`, updatedPriceRanges);
 
             try {
                 // Update Firestore with the modified priceRanges
                 const productRef = doc(db, 'products', product.id);
                 await updateDoc(productRef, {
                     priceRanges: updatedPriceRanges
                 });
               // Log the stock update
             const stockData = {
                 productId: product.id,
                 priceRanges: [{price:selectedPriceRange.price, stock:product.totalQuantity}],
                 updatedAt: new Date(),
                 customerId: selectedCustomer.cusmid,
                 schemeId: scheme.id,
                 schemeName: scheme.name,
                 type: 'Outward-stock',
             };
             await addDoc(collection(db, 'stock-management'), stockData);
        
                 console.log(`Stock successfully updated for ${product.name}`);
             } catch (error) {
                 console.error(`Error updating stock for ${product.name}:`, error);
             }
         }
             // Add delivery status in the subscriptions collection
             const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id), where('userId', '==', selectedCustomer.cusmid));
             const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
     
             if (!subscriptionsSnapshot.empty) {
                 const subscriptionDoc = subscriptionsSnapshot.docs[0];
                 const subscriptionRef = doc(db, 'subscriptions', subscriptionDoc.id);
                 await updateDoc(subscriptionRef, {
                     deliveryStatus: 'Processing',
                     invoiceNumber:invoiceNumber,
                     deliveryStatuscreatedAt: new Date(),
                     billingUser: currentUser ? currentUser.username : 'Unknown',
                     billingStatus: 'Billed',
                     PackingStatus: 'Assigned-for-packing',
                 });
             }
     
             // Generate delivery slip content
              const pdfDoc = new jsPDF();
          
                      // Generate Invoice Number
                    
              
                      // Calculate Total Bill Value
                      let totalBillValue = 0;
                      totalProducts.forEach(product => {
                          const selectedPriceRangeIndex = selectedPriceRanges[product.id];
                          const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
                          if (selectedPriceRange) {
                              totalBillValue += product.totalQuantity * selectedPriceRange.price;
                          }
                      });
              
                      // Calculate Total Savings
                      const totalSavings = scheme?.totalSchemeValue - totalBillValue;
              
                      // Add the logo
                      const logoUrl = `${process.env.PUBLIC_URL}/logo-full.png`; // Logo path
                      const logoWidth = 60;  // Adjusted width for better layout
                      const logoHeight = 30; // Adjusted height (assuming square logo)
                      const logoX = 10;
                      const logoY = 10;
                      pdfDoc.addImage(logoUrl, 'PNG', logoX, logoY, logoWidth, logoHeight);
              // Title next to the logo
                      const titleX = logoX + logoWidth + 10; // Space after logo
                      const titleY = logoY + 12; // Vertically align with logo
                      // Add title next to the logo
                   
                     // Set font for the heading
                      pdfDoc.setFontSize(22);
                      pdfDoc.setFont('helvetica', 'bold');
          
                      // Get the page width
                      const pageWidth = pdfDoc.internal.pageSize.getWidth();
          
                      // Define the text
                      const invoiceTitle = 'Invoice';
          
                      // Measure the text width
                      const textWidth = pdfDoc.getTextWidth(invoiceTitle);
          
                      // Calculate X position to center the text
                      const centerX = (pageWidth - textWidth) / 2;
          
                      // Add the centered Invoice text below the logo/title
                      pdfDoc.text(invoiceTitle, centerX, titleY + 10);
                      // Add date and invoice number on the top-right
                      pdfDoc.setFontSize(12);
                      const dateX = 200;
                      const dateY = 15;
                      pdfDoc.text(`Date: ${new Date().toLocaleString()}`, dateX, dateY, { align: 'right' });
                      pdfDoc.text(`Invoice No: ${invoiceNumber}`, dateX, dateY + 10, { align: 'right' });
              
                      // Add store address and delivery address on the same row
                      const addressStartY = 50; // Start below the logo and title
                      pdfDoc.setFontSize(12);
              
                      // Store Address
                      pdfDoc.text('Store Address:', 10, addressStartY);
                      const splitStoreAddress = pdfDoc.splitTextToSize(contactDetails.address || 'Not Available', 80);
                      pdfDoc.text(splitStoreAddress, 10, addressStartY + 5);
                      const storeAddressHeight = splitStoreAddress.length * 5;
                      const contactStoreStartY = addressStartY + storeAddressHeight + 5;
                      pdfDoc.text(`Phone: ${contactDetails.phone || 'Not Available'}`, 10, contactStoreStartY);
                      pdfDoc.text(`Email: ${contactDetails.email || 'Not Available'}`, 10, contactStoreStartY + 5);
              
                      // Delivery Address
                      const deliveryAddressStartX = 110; // Align delivery address to the right
                      pdfDoc.text('Delivery Address:', deliveryAddressStartX, addressStartY);
                      pdfDoc.text(`${selectedCustomer?.name || 'Not Available'}`, deliveryAddressStartX, addressStartY + 5);
                      const deliveryAddress = `${selectedCustomer?.address?.address || ''}, ${selectedCustomer?.address?.city || ''}, ${selectedCustomer?.address?.state || ''}, ${selectedCustomer?.address?.country || ''}, ${selectedCustomer?.address?.postalCode || ''}`;
                      const splitDeliveryAddress = pdfDoc.splitTextToSize(deliveryAddress, 80);
                      pdfDoc.text(splitDeliveryAddress, deliveryAddressStartX, addressStartY + 10);
                      const deliveryAddressHeight = splitDeliveryAddress.length * 5;
                      const contactDeliveryStartY = addressStartY + Math.max(storeAddressHeight, deliveryAddressHeight) + 10;
                      pdfDoc.text(`Phone: ${selectedCustomer?.phone || 'Not Available'}`, deliveryAddressStartX, contactDeliveryStartY);
                      pdfDoc.text(`Email: ${selectedCustomer?.email || 'Not Available'}`, deliveryAddressStartX, contactDeliveryStartY + 5);
              
                      // Add scheme details
                      const schemeDetailsStartY = contactDeliveryStartY + 15; // Ensure proper spacing
                      pdfDoc.text(`Scheme Name: ${scheme?.name || 'Not Available'}`, 10, schemeDetailsStartY);
                      pdfDoc.text(`Scheme Value: ${scheme?.totalSchemeValue || 0}`, 10, schemeDetailsStartY + 5);
              
                      // Prepare product details for the table
                      const productRows = totalProducts.map(product => {
                          const selectedPriceRangeIndex = selectedPriceRanges[product.id];
                          const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
                          const totalPrice = product.totalQuantity * (selectedPriceRange?.mrp || 0);
                          return [
                              product.name,
                              `${product.unitValue} ${product.unitType}`,
                              product.totalQuantity,
                              `${selectedPriceRange?.mrp || 0}`,
                              `${totalPrice}`,
                          ];
                      });
              
                      // Add Total Bill Value and Savings as rows in the table
                      productRows.push([
                          { content: 'Total Bill Value', colSpan: 4, styles: { halign: 'right', fontStyle: 'bold' } },
                          { content: `${totalBillValue.toFixed(2)}`, styles: { fontStyle: 'bold' } },
                      ]);
                     
                      productRows.push([
                        {
                          content: 'Total Savings',
                          colSpan: 4,
                          styles: {
                            halign: 'right',
                            fontStyle: 'bold',
                            textColor: '#2e7d32',      // Dark green
                            fillColor: '#e8f5e9',      // Light green background
                          },
                        },
                        {
                          content: `${totalSavings.toFixed(2)}`,
                          styles: {
                            fontStyle: 'bold',
                            textColor: '#2e7d32',
                            fillColor: '#e8f5e9',
                          },
                        },
                      ]);
                      
                      
                    
                      // Add product details table
                      const productDetailsStartY = schemeDetailsStartY + 15;
                      pdfDoc.text('Products:', 10, productDetailsStartY);
                      pdfDoc.autoTable({
                          startY: productDetailsStartY + 5,
                          head: [['Product Name', 'Measurement', 'Quantity', 'Price', 'Total']],
                          body: productRows,
                          styles: { fontSize: 10, cellPadding: 2 },
                      });
              
                      // Add signature spaces
                      const finalY = pdfDoc.lastAutoTable.finalY + 20;
                      pdfDoc.text(`Billing Person : ${selectedCustomer?.billingUserName || 'Unknown'}`, 10, finalY);
                      pdfDoc.text(`Packing Person : ${selectedCustomer?.logisticsUserName || 'Unknown'}`, 110, finalY);
                      
             // Export and Upload
             const pdfBlob = pdfDoc.output('blob');
             const storageRef = ref(storage, `deliverySlips/${selectedCustomer.cusmid}_${id}.pdf`);
             
             await uploadBytes(storageRef, pdfBlob);
             const deliverySlipURL = await getDownloadURL(storageRef);
             console.log(deliverySlipURL)
             await addDoc(collection(db, 'order-processing'), {
                 customerId: selectedCustomer.cusmid,
                 schemeId: scheme.id,
                 invoiceNumber:invoiceNumber,
                 products: totalProducts.map(product => ({
                     productId: product.id,
                     quantity: product.totalQuantity,
                     barcode: product.barcode
                 })),
                 deliveryStatus: 'Processing',
                 BillingStatus: 'Billed',
                 PackingStatus: 'Assigned-for-packing',
                 billingUser: currentUser ? currentUser.username : 'Unknown',
                 createdAt: new Date(),
                 deliverySlipURL: deliverySlipURL
             });
             fetchData();
             handleCloseModal();
             setToastMessage('Delivery processed successfully');
             setToastVariant('success');
             setShowToast(true);
         } catch (error) {
             console.error('Error processing order:', error);
             setToastMessage('Error processing order. Please try again.');
             setToastVariant('danger');
             setShowToast(true);
         } finally {
             setIsLoading(false);
         }
     };
    

    const handlePrintSlip = async (billedCustomers) => {
        try {
            console.log(billedCustomers)
            const storageRef = ref(storage, `deliverySlips/${billedCustomers.cusmid}_${billedCustomers.schemeId}.pdf`);
            const deliverySlipURL = await getDownloadURL(storageRef);
            window.open(deliverySlipURL, '_blank');
        } catch (error) {
            console.error('Error fetching delivery slip:', error);
            setToastMessage('Error fetching delivery slip. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };


    if (!scheme) {
    
            // Render loading screen
            return (
              <div className="loading-screen">
              <Loading/>
              </div>
            );
          
    }



    const sendNotificationToServer = async (fcmToken, customerName) => {
        try {
            await fetch("http://192.168.1.55:5000/api/send-notification", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ fcmToken, customerName })
            });
          } catch (error) {
            console.error("Error sending request to backend:", error);
        }
    };
    const handlePriceRangeChange = (productId, priceRangeIndex) => {
        setSelectedPriceRanges(prevState => ({
            ...prevState,
            [productId]: priceRangeIndex
        }));
    };

    

    return (
        <Container fluid className="mt-5">
            <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
         
                <Row>
                    <Col>
                        <h1>Billing</h1>
                        <h3>Scheme : {scheme.name}</h3>
                        <Button variant='outline-success' className='btn' onClick={syncData}>Sync</Button>
                    </Col>
                   <Col className="text-end">
                   <Row>
                   <Col md={4} sm={4} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{unBilledCustomers.length + billedCustomers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <center>
                                        <h5 className="cus-head">Total bills</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                       
                        <Col md={4} sm={4} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{billedCustomers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <center>
                                            <h5 className="cus-head">Billed</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} sm={4} className="mb-4">
                        <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{unBilledCustomers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                    <center>
                                        <h5 className="cus-head">Unbilled</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        </Row>
                    </Col>
                </Row>
           
            <Card className="h-100">
                        <Card.Body>
                            <h6>Products</h6>
                            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                            <Table striped bordered hover responsive >
                                <thead>
                                    <tr className='scheme-det-font-head'>
                                        <th>Product</th>
                                        <th>Measurement</th>
                                        <th>Quantity</th>
                                        <th>Stock</th>
                                    </tr>
                                </thead>
                               
                                <tbody>
                                    {products.map((product) => (
                                        <tr key={product.id} className='scheme-det-font'>
                                            <td>{product.name}</td>
                                            <td>{product.unitValue} {product.unitType}</td>
                                            <td>{product.quantity}</td>
                                            
                                            <td>
                                                {product.priceRanges.map((priceRange, index) => (
                                                    <div key={index}>
                                                        Price: {priceRange.price}, Stock: {priceRange.stock}
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>    
                            </div>
                        </Card.Body>
                    </Card>
<br/>
            <Tabs
                id="process-customer"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
            >
                <Tab eventKey="unbilled" title="Unbilled">
                    <Card className="mb-4">
                        <Card.Body>
                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr className='scheme-det-font-head'>
                                            <th>Id</th>
                                            <th>Name</th>
                                            <th>Phone</th>
                                            <th>Billing</th>
                                            <th>Packing</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {unBilledCustomers.length > 0 ? (
                                    unBilledCustomers.map((unBilledCustomers, index) => (
                                        <tr key={index} className='scheme-det-font'>
                                            <td>{unBilledCustomers.cusmid}</td>
                                            <td>{unBilledCustomers.name}</td>
                                            <td>{unBilledCustomers.phone}</td>
                                            <td>{billingUsers.find(user => user.id === unBilledCustomers.billingUserId)?.username || 'Not Assigned'}</td>
                                            <td>{logisticsUsers.find(user => user.id === unBilledCustomers.logisticsUserId)?.username || 'Not Assigned'}</td>
                                            <td>
                                                <Button variant="outline-primary" className='btn btn' onClick={() => handleShowModal(unBilledCustomers)}>
                                                    Genrate bill
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5">No customers found.</td>
                                    </tr>
                                )}
                                        {/* Add customer data here */}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Tab>
                <Tab eventKey="billed" title="Billed">
                    <Card className="mb-4">
                        <Card.Body>
                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr className='scheme-det-font-head'>
                                            <th>Id</th>
                                            <th>Invoice</th>
                                            <th>Name</th>
                                            <th>Phone</th>
                                            <th>Action</th>
                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {billedCustomers.length > 0 ? (
                                    billedCustomers.map((billedCustomers, index) => (
                                        <tr key={index} className='scheme-det-font'>
                                            <td>{billedCustomers.cusmid}</td>
                                            <td>{billedCustomers.invoiceNumber}</td>
                                            <td>{billedCustomers.name}</td>
                                            <td>{billedCustomers.phone}</td>
                                            <td>
                                                <Button variant="outline-secondary"style={{marginLeft:'5px'}} className='btn btn' onClick={() => handlePrintSlip(billedCustomers)}>
                                                    <FaPrint/> Print Slip
                                                </Button>
                                            </td>
                                        
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5">No customers found.</td>
                                    </tr>
                                )}
                                        {/* Add customer data here */}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Tab>
            </Tabs>
            <Modal show={showModal} onHide={handleCloseModal} size='xl'>
    <Modal.Header closeButton>
        <Modal.Title>Customer Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {selectedCustomer && (
            <>
                <p><strong>Name:</strong> {selectedCustomer.name}</p>
                <p><strong>Email:</strong> {selectedCustomer.email}</p>
                <p><strong>Phone:</strong> {selectedCustomer.phone}</p>
                <p><strong>Address:</strong> {selectedCustomer.address.address}</p>
                <p><strong>Purchased quantity:</strong>{selectedCustomer.quantity}</p>
                <h5>Products</h5>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <Table responsive>
                        <thead>
                            <tr className='scheme-det-font-head'>
                                <th>Product Name</th>
                                <th>Barcode</th>
                                <th>Scanned Quantity</th>
                                <th>Total Quantity</th>
                                <th>Price Range</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalProducts.map((product, index) => (
                                <tr key={index}>
                                    <td>{product.name} - {product.unitValue} {product.unitType}</td>
                                    <td>
                                        <Form.Group className="">
                                            <Form.Control
                                                type="text"
                                                placeholder="Scan barcode"
                                                value={scannedBarcodes[product.id] || ''}
                                                onChange={(e) => handleBarcodeChange(product.id, e.target.value)}
                                            />
                                        </Form.Group>
                                    </td>
                                    <td>{scannedQuantities[product.id] || 0}</td>
                                    <td>{product.totalQuantity}</td>
                                    <td>
                                        <Form.Group className="">
                                            <Form.Control
                                                as="select"
                                                value={selectedPriceRanges[product.id] || ''}
                                                onChange={(e) => handlePriceRangeChange(product.id, e.target.value)}
                                            >
                                                <option value="" disabled>Select Price Range</option>
                                                {product.priceRanges.map((priceRange, index) => (
                                                    <option key={index} value={index}>
                                                        Price: {priceRange.price}, Stock: {priceRange.stock}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                {barcodeError && <Alert variant="danger">{barcodeError}</Alert>}
            </>
        )}
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
            Close
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? <Loading /> : 'Generate bill'}
        </Button>
    </Modal.Footer>
</Modal>
                    
         
        </Container>
    );
};

export default ProcessScheme;